import React from 'react';
import { Spinner as CrateSpinner, Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import { RegionReportFooter as RegionYieldReportFooter } from '../RegionReportFooter/RegionReportFooter';
import styles from '../RegionReport.css';

export type RegionReportSpinnerProps = {
  onCancelClick: () => void;
}

export const RegionReportSpinner = ({ onCancelClick }: RegionReportSpinnerProps) => (
  <div>
    <h2 className={styles.title}>
      {getMessage('regions.report.modal.fieldReport')}
    </h2>
    <Icon
      className={styles.closeModalTitle}
      glyph={Icon.set.REMOVE}
      onClick={onCancelClick}
      testId='region-report-spinner-close-icon'
    />
    <div className={styles.spinnerWrapper}>
      <CrateSpinner />
      <p>{getMessage('regions.report.modal.spinnerMsg')}</p>
    </div>
    <RegionYieldReportFooter
      onCancelClick={onCancelClick}
      showSaveButton={false}
    />
  </div>
);
